/**
 * @fileoverview Provides a utility function to parse and extract code block content from markdown-style code fences. The function returns the inner content of a code block if found, otherwise returns the original content.
 */

export function parsePossibleCodeBlock(content: string): string {
  const codeBlockRegex = /```[\w-]*\n([\s\S]*)\n```/
  const match = content.match(codeBlockRegex)

  if (match) {
    return match[1]!
  }

  return content
}
